/* eslint-disable no-restricted-globals */
import React, { Component, Fragment, createRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  withStyles,
  // Paper,
  Grid,
  Button,
  Menu,
  MenuItem,
  Hidden,
} from '@material-ui/core';
import { ArrowDropDown, VerifiedUser } from '@material-ui/icons';
import { read } from 'actions/data';
import { toggleManagePhonesModal } from 'actions/tasks';
import { toggleAcquireNumberDisplay } from '../../actions/phonenumbers';
import styles from './styles';
import DataPanel from 'components/theme/DataPanel';
import { themeObj } from 'components/withRoot';
import { bullets } from 'components/Pricing';
import { stepperGoTo } from 'actions/view';
import { openPaymentsModal, getPlans } from 'actions/paymentsManager';
import Tooltip from 'components/theme/HelpTooltip.js';
import numberWithCommas from 'utils/numberWithCommas'

const mapStateToProps = (state) => ({
  accountusage: state.data['account/usage'],
  overages: state.data?.overages,
  subscription: state.paymentsManager?.subscription,
  plansByID: state.paymentsManager?.plans?.reduce?.((acc, plan) => {
    acc[plan.id] = plan;
    return acc;
  }, {}),
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      read,
      toggleAcquireNumberDisplay,
      toggleManagePhonesModal,
      stepperGoTo,
      openPaymentsModal,
      getPlans,
    },
    dispatch
  );
};

const urlParams = new URLSearchParams(window.location.search);
const jwtToken = urlParams.get('jwtToken');

const getTransactions = (subscription) =>
  subscription?.transactions?.filter?.(
    (transaction) => transaction?.type === 'sale'
  );
export class BillingCycleButton extends Component {
  state = {
    anchorEl: null,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const { subscription, setCycle, cycle } = this.props;

    const transactions = getTransactions(subscription);

    return !transactions?.length ? null : (
      <Fragment>
        <Button
          variant='contained'
          color='secondary'
          style={{
            borderTopLeftRadius: 35,
            borderBottomLeftRadius: 35,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          }}
          onClick={this.handleClick}
        >
          {`Billing: ${transactions?.[cycle]?.subscription?.billingPeriodStartDate} to ${transactions?.[cycle]?.subscription?.billingPeriodEndDate}`}
        </Button>
        <Button
          aria-owns={anchorEl ? 'billing-cycle-menu' : undefined}
          aria-haspopup='true'
          onClick={this.handleClick}
          variant='contained'
          color='secondary'
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderTopRightRadius: 35,
            borderBottomRightRadius: 35,
            padding: 6,
            minWidth: 0,
          }}
        >
          <ArrowDropDown />
        </Button>
        <Menu
          id='billing-cycle-menu'
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {transactions?.map((transaction, idx) => (
            <MenuItem
              key={`billingCycleMenuItem${idx}`}
              onClick={() => {
                // history.push('/contacts/upload')
                setCycle(idx);
                this.handleClose();
              }}
            >
              {`${transaction?.subscription?.billingPeriodStartDate} to ${transaction?.subscription?.billingPeriodEndDate}`}
            </MenuItem>
          ))}
        </Menu>
      </Fragment>
    );
  }
}

export const additionalUsageCalculator = (
  accountusage,
  overages,
  subscription,
  cycle
) => {
  const subscription_limits =
    overages?.[
      getTransactions(subscription)?.[cycle]?.planId || subscription?.planId
    ];

  let overageAmount = 0;

  const email_overage =
    accountusage?.total_emails_received +
    accountusage?.total_emails_sent -
    subscription_limits?.email_limit;
  if (email_overage > 0)
    overageAmount += email_overage * subscription_limits?.email_overage_cost;

  const phone_number_overage =
    accountusage?.max_phone_numbers - subscription_limits?.phone_number_limit;
  if (phone_number_overage > 0)
    overageAmount +=
      phone_number_overage * subscription_limits?.phone_number_overage_cost;

  const storage_overage =
    accountusage?.max_s3_bytes / 1073741824 -
    subscription_limits?.storage_limit;
  if (storage_overage > 0)
    overageAmount +=
      storage_overage * subscription_limits?.storage_overage_cost;

  const text_overage =
    accountusage?.total_sms_received +
    accountusage?.total_sms_sent -
    subscription_limits?.text_limit;
  if (text_overage > 0)
    overageAmount += text_overage * subscription_limits?.text_overage_cost;

  const user_overage =
    accountusage?.max_users - subscription_limits?.user_limit;
  if (user_overage > 0)
    overageAmount += user_overage * subscription_limits?.user_overage_cost;

  const voice_overage =
    accountusage?.total_inbound_voice_seconds / 60 +
    accountusage?.total_outbound_voice_seconds / 60 -
    subscription_limits?.voice_limit;
  if (voice_overage > 0)
    overageAmount += voice_overage * subscription_limits?.voice_overage_cost;

  return {
    subscription_limits,
    overageAmount,
    email_overage,
    phone_number_overage,
    storage_overage,
    text_overage,
    user_overage,
    voice_overage,
  };
};

class AdditionalUsage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // anchorEl: null,
      cycle: 0,
      height: 0,
    };
    this.ref = createRef();
  }

  componentDidMount() {
    // console.log('AdditionalUsage componentDidMount')
    const { subscription, read, getPlans } = this.props;

    getPlans();

    if (subscription) {
      read(
        undefined,
        'account/usage',
        `account/usage?st=${
          new Date(subscription.billingPeriodStartDate).getTime() / 1000
        }&et=${new Date(subscription.billingPeriodEndDate).getTime() / 1000}`,
        'none'
      );
    }

    setTimeout(() => {
      if (this.ref?.current?.clientHeight) {
        this.setState({ height: this.ref?.current?.clientHeight });
      }
    }, 1);
  }

  componentDidUpdate(prevProps, prevState) {
    const { subscription, read } = this.props;
    if (
      Boolean(prevProps.subscription) !== Boolean(this.props.subscription) &&
      subscription
    ) {
      read(
        undefined,
        'account/usage',
        `account/usage?st=${
          new Date(subscription.billingPeriodStartDate).getTime() / 1000
        }&et=${new Date(subscription.billingPeriodEndDate).getTime() / 1000}`,
        'none'
      );
    }

    if (prevState.cycle !== this.state.cycle) {
      read(
        undefined,
        'account/usage',
        `account/usage?st=${
          new Date(
            getTransactions(subscription)[
              this.state.cycle
            ].subscription.billingPeriodStartDate
          ).getTime() / 1000
        }&et=${
          new Date(
            getTransactions(subscription)[
              this.state.cycle
            ].subscription.billingPeriodEndDate
          ).getTime() / 1000
        }`,
        'none'
      );
    }
  }

  render() {
    const { accountusage, classes, overages, subscription, plansByID } =
      this.props;
    const { cycle } = this.state;

    let renderedComponent = <div>Loading usage data...</div>;

    if (accountusage && overages && subscription) {
      const {
        subscription_limits,
        overageAmount,
        email_overage,
        phone_number_overage,
        storage_overage,
        text_overage,
        user_overage,
        voice_overage,
      } = additionalUsageCalculator(
        accountusage,
        overages,
        subscription,
        cycle
      );

      const gigabytesUsed = accountusage.max_s3_bytes / 1073741824;
      const percentageOfGigabytesUsed =
        gigabytesUsed / subscription_limits?.storage_limit;

      const email_total =
        accountusage?.total_emails_received + accountusage?.total_emails_sent;

      const planPrice = parseFloat(
        plansByID?.[
          getTransactions(subscription)?.[cycle]?.planId || subscription?.planId
        ]?.price
      );
      const totalAmount = planPrice + overageAmount;

      const storageBackgroundColor = () => {
        if (storage_overage > 0) return themeObj.palette.red;

        if (percentageOfGigabytesUsed > 0.9) {
          return themeObj.palette.orange;
        }

        return themeObj.palette.green;
      };

      const totalMinutes =
        accountusage.total_inbound_voice_seconds / 60 +
        accountusage.total_outbound_voice_seconds / 60;
      const totalMinutesDisplay =
        typeof totalMinutes === 'number' && !Number.isInteger(totalMinutes)
          ? totalMinutes.toFixed(2)
          : totalMinutes;

      const panels = (
        <>
          <Grid item xs>
            <DataPanel
              fontSize={'1.5rem'}
              color={user_overage > 0 ? 'red' : 'green'}
              value={`${numberWithCommas(accountusage.max_users)}/${numberWithCommas(subscription_limits?.user_limit)}`}
              label='Users'
            />
          </Grid>
          <Grid item xs>
            <DataPanel
              fontSize={'1.5rem'}
              color={email_overage > 0 ? 'red' : 'green'}
              value={`${numberWithCommas(email_total)}/${numberWithCommas(subscription_limits?.email_limit)}`}
              label='Sent & Received Emails'
            />
          </Grid>
          <Grid item xs>
            <Hidden mdDown>
              <DataPanel
                fontSize={'1.5rem'}
                color={text_overage > 0 ? 'red' : 'green'}
                value={`${
                  numberWithCommas(accountusage.total_sms_received + accountusage.total_sms_sent)
                  }/${numberWithCommas(subscription_limits?.text_limit)}`}
                label='Sent & Received Text Messages'
              />
            </Hidden>
            <Hidden lgUp>
              <DataPanel
                fontSize={'1.5rem'}
                color={text_overage > 0 ? 'red' : 'green'}
                value={`${
                  numberWithCommas(accountusage.total_sms_received + accountusage.total_sms_sent)
                  }/${numberWithCommas(subscription_limits?.text_limit)}`}
                label='Sent & Received Texts'
              />
            </Hidden>
          </Grid>
          <Grid item xs>
            <DataPanel
              fontSize={'1.5rem'}
              color={phone_number_overage > 0 ? 'red' : 'green'}
              value={`${numberWithCommas(accountusage.max_phone_numbers)}/${numberWithCommas(subscription_limits?.phone_number_limit)}`}
              label='Phone Numbers'
            />
          </Grid>
          <Grid item xs>
            <DataPanel
              fontSize={'1.5rem'}
              color={voice_overage > 0 ? 'red' : 'green'}
              value={`${numberWithCommas(totalMinutesDisplay)}/${numberWithCommas(subscription_limits?.voice_limit)}`}
              label='Voice Minutes'
            />
          </Grid>
        </>
      );

      renderedComponent = (
        <div style={{ height: '100%' }}>
          <div className={classes.top} ref={this.ref}>
            <Hidden smDown>
              <Grid
                justify='space-between'
                container
                style={{ marginBottom: 12 }}
              >
                <Grid item>
                  <div className={classes.titleText}>
                    USAGE & DATA{' '}
                    <Tooltip>
                      <span>
                        Usage & Data is a breakdown of your additional usage
                        costs. Whenever you exceed your plan limits you will
                        incur additional usage costs, these costs details can be
                        found on Step 3 of the Subscription details. However,
                        Usage & Data is a breakdown of your additional usage
                        costs on your current billing cycle.
                      </span>
                    </Tooltip>
                  </div>
                </Grid>
                <Grid item>
                  <BillingCycleButton
                    setCycle={(idx) => this.setState({ cycle: idx })}
                    cycle={cycle}
                    subscription={subscription}
                  />
                </Grid>
              </Grid>
            </Hidden>
            <Hidden mdUp>
              <div style={{ marginBottom: 10 }}>
                <div className={classes.titleText}>
                  USAGE & DATA{' '}
                  <Tooltip>
                    <span>
                      Usage & Data is a breakdown of your additional usage
                      costs. Whenever you exceed your plan limits you will incur
                      additional usage costs, these costs details can be found
                      on Step 3 of the Subscription details. However, Usage &
                      Data is a breakdown of your additional usage costs on your
                      current billing cycle.
                    </span>
                  </Tooltip>
                </div>
                <BillingCycleButton
                  setCycle={(idx) => this.setState({ cycle: idx })}
                  cycle={cycle}
                  subscription={subscription}
                />
              </div>
            </Hidden>
            <Hidden smDown>
              <Grid container justify='center' spacing={16}>
                {panels}
              </Grid>
            </Hidden>
            <Hidden mdUp>
              <Grid container justify='center' spacing={8}>
                {panels}
              </Grid>
            </Hidden>
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <div style={{ marginBottom: 5 }}>Storage</div>
              <div
                style={{
                  border: '1px solid #000',
                  backgroundColor: '#B6B6B6',
                  height: 30,
                  borderRadius: 28,
                  overflow: 'hidden',
                  marginBottom: 10,
                }}
              >
                <div
                  style={{
                    backgroundColor: storageBackgroundColor(),
                    width: `${percentageOfGigabytesUsed}%`,
                    maxWidth: '100%',
                    height: 30,
                  }}
                />
              </div>
              <div>
                <Grid container justify='space-between'>
                  <Grid item>
                    <div style={{ marginRight: 20, display: 'inline-block' }}>
                      <div
                        style={{
                          display: 'inline-block',
                          height: 20,
                          width: 20,
                          border: '1px solid #000',
                          backgroundColor: storageBackgroundColor(),
                          marginRight: 10,
                        }}
                      />
                      <span
                        style={{
                          fontSize: 24,
                          marginRight: 5,
                        }}
                      >
                        Used Storage
                      </span>
                      <span style={{ fontSize: 14, color: '#808080' }}>
                        {`(${gigabytesUsed.toFixed(3)}GB)`}
                      </span>
                    </div>
                    <div style={{ display: 'inline-block' }}>
                      <div
                        style={{
                          display: 'inline-block',
                          height: 20,
                          width: 20,
                          border: '1px solid #000',
                          backgroundColor: '#B6B6B6',
                          marginRight: 10,
                        }}
                      />
                      <span
                        style={{
                          fontSize: 24,
                          marginRight: 5,
                        }}
                      >
                        Unused Storage
                      </span>
                      <span style={{ fontSize: 14, color: '#808080' }}>
                        {`(${
                          gigabytesUsed > subscription_limits?.storage_limit
                            ? 0
                            : subscription_limits?.storage_limit -
                              gigabytesUsed.toFixed(3)
                        }GB)`}
                      </span>
                    </div>
                  </Grid>
                  <Grid item>
                    {storage_overage > 0 ? (
                      <div
                        style={{
                          fontSize: 14,
                          color: storageBackgroundColor(),
                        }}
                      >
                        *You have exceeded what's included
                      </div>
                    ) : percentageOfGigabytesUsed > 0.9 ? (
                      <div
                        style={{
                          fontSize: 14,
                          color: storageBackgroundColor(),
                        }}
                      >
                        *You are about to exceed what's included
                      </div>
                    ) : null}
                  </Grid>
                </Grid>
              </div>
            </div>
            {!jwtToken && (
              <div
                style={{ textAlign: 'center', fontSize: 14, paddingBottom: 20 }}
              >
                You can save money and upgrade your plan{' '}
                {/* eslint-disable-next-line */}
                <a
                  onClick={() => {
                    this.props.openAdditionalUsageModal(false);
                    this.props.openPaymentsModal(true);
                    this.props.stepperGoTo(2, 'pricing');
                  }}
                  href='#'
                >
                  here
                </a>
                .
              </div>
            )}
          </div>
          <div style={{ height: 1, backgroundColor: '#808080' }} />
          <table
            // container
            // alignItems="stretch"
            // justify="space-between"
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              // height: `calc(100% - ${this.state.height}px)`,
              // height: this.state.height ? `calc(100% - ${this.state.height})` : 250,
            }}
          >
            <tr>
              <td className={classes.planBlock}>
                <VerifiedUser
                  style={{
                    fontSize: 100,
                    color: themeObj.palette.pink,
                    marginBottom: 5,
                    marginTop: 15,
                  }}
                />
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 'bold',
                    marginBottom: 4,
                  }}
                >
                  {
                    plansByID?.[
                      getTransactions(subscription)?.[cycle]?.planId ||
                        subscription?.planId
                    ]?.name
                  }
                </div>
                {!jwtToken && (
                  <div
                    style={{
                      fontSize: 14,
                      color: '#808080',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      this.props.openAdditionalUsageModal(false);
                      this.props.openPaymentsModal(true);
                      this.props.stepperGoTo(2, 'pricing');
                    }}
                  >
                    See other plans
                  </div>
                )}
              </td>
              <td className={classes.planBlock}>
                <div
                  style={{
                    fontSize: 16,
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                  }}
                >
                  PLAN DETAILS
                </div>
                <div style={{ textAlign: 'left' }}>
                  {bullets(
                    overages,
                    getTransactions(subscription)?.[cycle]?.planId ||
                      subscription?.planId
                  )}
                </div>
              </td>
              <td className={classes.planBlock}>
                <div
                  style={{
                    fontSize: 16,
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                  }}
                >
                  PRICE
                </div>
                <div style={{ fontSize: 35 }}>
                  $
                  {
                    plansByID?.[
                      getTransactions(subscription)?.[cycle]?.planId ||
                        subscription?.planId
                    ]?.price
                  }
                </div>
              </td>
              <td className={classes.planBlock}>
                <div
                  style={{
                    fontSize: 16,
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                  }}
                >
                  ADDITIONAL USAGE
                </div>
                <div style={{ fontSize: 35 }}>
                  ${overageAmount?.toFixed?.(2)}*
                </div>
                <em>*Price may vary at time of billing</em>
              </td>
              <td className={classes.planBlock}>
                <div
                  style={{
                    fontSize: 16,
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                  }}
                >
                  TOTAL
                </div>
                <div style={{ fontSize: 12 }}>
                  {'(Price + Additional Usage)'}
                </div>

                <div
                  style={{
                    fontSize: 38,
                    color: themeObj.palette.green,
                    fontWeight: 'bold',
                    // marginBottom: 4,
                  }}
                >
                  $
                  {isNaN(totalAmount?.toFixed?.(2))
                    ? '0.00'
                    : totalAmount?.toFixed?.(2)}
                  *
                </div>
                {cycle === 0 && (
                  <div style={{ color: '#808080' }}>
                    Payment due <strong>{subscription.nextBillingDate}</strong>
                  </div>
                )}
                <em style={{ color: themeObj.palette.green }}>*</em>
                <em>Does not include taxes</em>
              </td>
            </tr>
          </table>
          {/* <Hidden smDown>
            <div style={{ height: 1, backgroundColor: '#808080' }} />
          </Hidden> */}
        </div>
      );
    }

    return renderedComponent;
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AdditionalUsage));
